import { ANALYTICS_KEY } from "../utils/constants";

export const saveForGoogleAnalyticsToSessionStorage = (type: string): void => {
  sessionStorage.setItem(ANALYTICS_KEY, type);
};
